import React from "react";

const PASOS = ['Valoramos', 'Planificamos', 'Medimos', 'Ajustamos']
const ADAPTADO_A = ['Tu objetivo', 'Tu situación', 'Tu estilo de vida']

const PlanParaTi = () => {
    return (
        <section className='relative w-full bg-whiteBG text-bgBlack pt-28 pb-28 lg:pt-36 lg:pb-36 px-6 flex flex-col items-center overflow-hidden' data-testid="plan-section">
            {/* Degradados suaves de entrada y salida (negro -> blanco -> negro) */}
            <div aria-hidden="true" className='section-fade-top pointer-events-none absolute inset-x-0 top-0 h-28 lg:h-40'/>
            <div aria-hidden="true" className='section-fade-bottom pointer-events-none absolute inset-x-0 bottom-0 h-28 lg:h-40'/>
            <div className='relative w-full max-w-5xl flex flex-col lg:flex-row items-center gap-10 lg:gap-14'>
                <div className='flex-1 flex flex-col items-center lg:items-start text-center lg:text-left'>
                    <h2 className='text-3xl lg:text-4xl font-black uppercase'>Un plan hecho para ti</h2>

                    <div className='mt-8 flex flex-wrap justify-center lg:justify-start gap-3'>
                        {PASOS.map((paso, i) => (
                            <div key={paso} className='flex items-center gap-3'>
                                <span className='py-2 px-5 bg-bgBlack text-white rounded-full font-bold uppercase text-sm'>{paso}</span>
                                {i < PASOS.length - 1 && <span className='text-sbPallet-accent font-black'>·</span>}
                            </div>
                        ))}
                    </div>

                    <p className='mt-10 font-bold'>Nutrición y entrenamiento adaptados a:</p>

                    <div className='mt-4 flex flex-wrap justify-center lg:justify-start gap-4'>
                        {ADAPTADO_A.map((item) => (
                            <span key={item} className='py-2 px-6 border-2 border-bgBlack rounded-lg font-black uppercase text-sm'>{item}</span>
                        ))}
                    </div>

                    <p className='mt-10 text-2xl font-black uppercase text-sbPallet-accent'>Nada genérico.</p>
                </div>

                <div className='flex-1 w-full max-w-md lg:max-w-none'>
                    <img className='w-full aspect-[4/5] rounded-2xl object-cover'
                         src="/assets/transformaciones/portada-coach.jpeg"
                         alt="Raúl Pérez entrenando a una clienta"/>
                </div>
            </div>
        </section>
    )
}

export default PlanParaTi
